export default "__VITE_ASSET__CuCuDtU___"